import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setChannel } from '../features/channelSlice';

export default function ChannelRedirect() {
  const { channelName } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { channels, status } = useSelector((state) => state.channel);

  useEffect(() => {
    // Wait until the config has been loaded
    if (status === 'succeeded') {
      // Check if the channel from the URL is a valid channel
      if (channelName && channels.includes(channelName)) {
        dispatch(setChannel(channelName));
      }
      // After setting the channel (or if the channel is invalid),
      // redirect to the root path to let MainApp render the view.
      navigate('/');
    }
  }, [channelName, dispatch, channels, navigate, status]);

  // Render nothing, or a loading spinner, while redirecting.
  return null;
}
